import React, { FC } from 'react'
import { BtInput } from './BtInput'

interface BtPercentageInputProps {
  value: number | string
  maxValue?: number
  label?: string
  testID?: string
  onChangeText: (e) => void
  validate: (e: string | undefined) => string
}

export const BtPercentageInput: FC<BtPercentageInputProps> = ({
  value,
  maxValue = 100,
  label,
  testID,
  onChangeText,
  validate,
}) => {
  const handleOnChange = (text: string) => {
    const percentage = Number(text)
    if (percentage <= maxValue) {
      onChangeText(percentage)
    }
  }

  return (
    <BtInput
      inputMask="999"
      value={value ? value.toString() : undefined}
      testID={testID}
      keyboardType="numeric"
      label={label}
      placeholder="%"
      onChangeText={handleOnChange}
      validateInput={validate}
      validateInputOnBlur
    />
  )
}
